// extracted by mini-css-extract-plugin
export default {"Snackbar":"SnackBar_Snackbar__eD+2k","viewNotification":"SnackBar_viewNotification__pGS32"};